import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../store";
import {
  deleteSingleOfferResponse,
  exportPdf,
  getOfferResponses,
} from "../modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    offerResponses: state.offerResponseReducer.offerResponses,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getOfferResponses,
      deleteSingleOfferResponse,
      exportPdf,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
